import { useRef, useState, DragEvent } from 'react';
import { ArrowUpIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface UploadBoxProps {
  accept: string;
  hintLabel: string;
  accentColor: string;
  onFileSelected: (file: File) => void;
}

function UploadBox({ accept, hintLabel, accentColor, onFileSelected }: UploadBoxProps) {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [dragActive, setDragActive] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const picked = e.target.files && e.target.files[0];
    if (picked) onFileSelected(picked);
  };

  const handleDrop = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setDragActive(false);
    const dropped = e.dataTransfer.files && e.dataTransfer.files[0];
    if (dropped) onFileSelected(dropped);
  };

  return (
    <div
      onDragOver={(e) => {
        e.preventDefault();
        setDragActive(true);
      }}
      onDragLeave={() => setDragActive(false)}
      onDrop={handleDrop}
      className={`mb-4 flex flex-col items-center justify-center gap-3 rounded-xl border-2 border-dashed px-6 py-8 text-center transition-colors ${
        dragActive ? 'border-current bg-muted' : 'border-input bg-muted'
      }`}
      style={dragActive ? { borderColor: accentColor } : undefined}
    >
      <Button
        onClick={() => fileInputRef.current?.click()}
        style={{ backgroundColor: accentColor }}
        className="text-white hover:opacity-90"
      >
        <ArrowUpIcon /> Upload
      </Button>
      <span className="text-sm text-muted-foreground">or drag and drop a file here</span>
      <span className="text-xs text-muted-foreground">{hintLabel}</span>
      <input ref={fileInputRef} type="file" accept={accept} onChange={handleChange} hidden />
    </div>
  );
}

export default UploadBox;
